import HorizontalScroll from '~/components/HorizontalScroll';
import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import type { OAISchema } from '~/types/openapi';
import { changedByFontScale } from '~/utils/fontScale';

import ECouponProductCard from '../components/ECouponProductCard';
import ProductCard from '../components/ProductCard';

interface Props {
  products: OAISchema['MarketSelectProductResponseV2'][];
  eventOption?: Record<string, unknown>;
}

const ProductCarouselDisplay = ({ products, eventOption = {} }: Props) => {
  return (
    <HorizontalScroll
      itemViewportWidth={changedByFontScale() ? 41 : 36}
      gap={16}
    >
      {products.map((product) => {
        if (product.productType === PRODUCT_TYPE_E_COUPON) {
          return (
            <ECouponProductCard
              key={product.offerId}
              {...product}
              eventOption={eventOption}
              plusMembershipFullBadge
              reverseCouponDiscountedPrice
            />
          );
        }
        return (
          <ProductCard
            key={product.offerId}
            {...product}
            eventOption={eventOption}
            plusMembershipFullBadge
            reverseCouponDiscountedPrice
          />
        );
      })}
    </HorizontalScroll>
  );
};

export default ProductCarouselDisplay;
